export default __webpack_public_path__ + "static/appjamming20192-2428d1df72ca68b6d152ffa14bee20f8.jpg";